import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../../../services';
import {RoleService} from '../../../services/role.service';
import {getAuthToken, setAuthToken} from '../../../helpers/storage-helper';

@Component({
  selector: 'app-enter-two-factor',
  templateUrl: './enter-two-factor.component.html',
  styleUrls: ['./enter-two-factor.component.css']
})
export class EnterTwoFactorComponent implements OnInit {

  twoFactorForm: FormGroup;
  totp: string;
  loading: boolean;
  username: string | null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private roleService: RoleService,
  ) {
  }

  ngOnInit() {
    this.initForm();
  }

  parseJwt(token: string): any {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
  }

  initForm() {
    const token = getAuthToken();
    const tokenInfo = this.parseJwt(token);

    this.username = tokenInfo?.sub;

    this.twoFactorForm = this.formBuilder.group({
      totp: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(8)]],
    });
  }

  onSubmit(form: FormGroup) {
    const returnUrl = this.route.snapshot.queryParams['returnUrl'] || '';

    this.loading = true;
    this.totp = this.twoFactorForm.get('totp').value as string;

    this.authService.sendTotp(this.totp).subscribe(data => {
      const remind = true; // TODO make this possible..?

      setAuthToken(data.authToken, remind);
      this.roleService.setRoles(data.roles, remind);

      this.router.navigate(['start'], {queryParams: {returnUrl}});
    }, err => {
      this.loading = false;
      console.log(err);
    });
  }

}
